exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table th.gutter {\n  display: table-cell !important;\n}\n", ""]);

// exports
